import Vue from 'vue/dist/vue.esm'
import template from './district_next_step_per_school_report_template.slim'
import { seriesData, mergeCountsBar } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';
import barChartRange from '../../mixins/bar_chart_range';

Vue.component('district_next_step_per_school_report', {
  mixins: [template, chartFilterable, barChartRange],
  props: ['school_year_label', 'year_info', 'report_date', 'section'],
  data() {
    const nextStepsTerm = this.$nextStepsTerm();
    return {
      nextStepsTerm,
      chartData: {
        completed: {},
        not_completed: {}
      },
      series: [{
        name: 'Completed',
        data: []
      }, {
        name: 'Open',
        data: []
      }],
      chartOptions: {
        dataLabels: {
          enabled: false
        },
        chart: {
          type: 'bar',
          stacked: true,
        },
        yaxis: {
          title: {
            text: `District ${nextStepsTerm}`,
            style: {
              color: '#949494'
            }
          },
          forceNiceScale: true
        },
        xaxis: {
          labels: {
            trim: true,
            rotate: -55,
          }
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          },
          padding: {
            left: 50,
            bottom: 30
          },
        },
        colors:['#3FE6A4', '#008FFB']
      }
    }
  },
  methods: {
    updateChart: function() {
      let series = [{
        name: 'Completed',
        data: seriesData(mergeCountsBar(this.chartData.completed, this.startDate, this.endDate))
      }, {
        name: 'Open',
        data: seriesData(mergeCountsBar(this.chartData.not_completed, this.startDate, this.endDate))
      }];
      let sums = {};
      series.forEach(item => {
        item.data.forEach(({ x, y }) => {
          sums[x] = (sums[x] || 0) + y;
        });
      });

      series.forEach(item => {
        item.data.sort((a, b) => sums[b.x] - sums[a.x]);
      });
      this.series = series;
    }
  }
});
